import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Embed iframe — lock the document size + suppress scrollbar gutter BEFORE
// React mounts. Doing it inside a React useEffect runs too late: by then the
// browser has already reserved space for a potential scrollbar and the gutter
// stays visible even after we set overflow:hidden.
if (typeof window !== 'undefined' && /[?&]embed=true(&|$)/.test(window.location.search)) {
  var __html = document.documentElement;
  __html.style.height = '100%';
  __html.style.width = '100%';
  __html.style.overflow = 'hidden';
  __html.style.margin = '0';
  if (document.body) {
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.margin = '0';
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);